module.exports = __webpack_public_path__ + "static/media/New.994af8fb.svg";